// extracted by mini-css-extract-plugin
module.exports = {"landingFeatureList":"LandingFeatureList_landingFeatureList__2u8AA","title":"LandingFeatureList_title__1GHg8","list":"LandingFeatureList_list__2Lwq-"};